import { createClient } from '@supabase/supabase-js';

/**
 * Supabase Client Setup
 *
 * Provides the Supabase client for database access and Realtime subscriptions.
 * Uses environment variables for configuration.
 */

// Default to hardcoded values for development (env vars can override)
const supabaseUrl = 'https://dqftcixhsvcjtyxsxoao.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRxZnRjaXhoc3ZjanR5eHN4b2FvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjcyMTgzMTYsImV4cCI6MjA4Mjc5NDMxNn0.erZq0zJMF-tATX7b0mofGsajFUvcqlZE5PQ4qcggmGc';

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  realtime: {
    params: {
      eventsPerSecond: 10,
    },
  },
});

// Database types for Machina VTT tables
export interface DbUser {
  id: string;
  display_name: string | null;
  created_at: string;
}

export interface DbCampaign {
  id: string;
  owner_id: string | null;
  name: string;
  description: string | null;
  settings: Record<string, unknown>;
  playset: string | null;
  created_at: string;
  updated_at: string;
}

export interface DbCampaignMember {
  campaign_id: string;
  user_id: string;
  role: 'dm' | 'player';
  joined_at: string;
}

export interface DbCampaignInvite {
  id: string;
  campaign_id: string;
  code: string;
  email: string | null;
  created_by: string;
  status: 'pending' | 'accepted' | 'expired' | 'revoked';
  expires_at: string | null;
  max_uses: number | null;
  use_count: number;
  created_at: string;
  accepted_at: string | null;
  accepted_by: string | null;
}

export interface DbCharacter {
  id: string;
  user_id: string | null;
  campaign_id: string | null;
  data: Record<string, unknown>;
  created_at: string;
  updated_at: string;
}

export interface DbChatMessage {
  id: string;
  campaign_id: string | null;
  user_id: string | null;
  message_type: 'text' | 'dice' | 'system' | 'dm' | 'spell' | 'npc' | 'ai_dm' | 'roll_request';
  content: Record<string, unknown>;
  created_at: string;
}

export interface DbScene {
  id: string;
  campaign_id: string | null;
  name: string;
  is_active: boolean;
  map_data: Record<string, unknown>;
  created_at: string;
  updated_at: string;
}

export interface DbToken {
  id: string;
  scene_id: string | null;
  character_id: string | null;
  data: Record<string, unknown>;
  created_at: string;
  updated_at: string;
}

export interface DbInitiativeEntry {
  id: string;
  scene_id: string | null;
  data: Record<string, unknown>;
  created_at: string;
}
